import { useEffect, useState } from 'react';
import Box from 'elements/Box';
import {
  Button,
  Chip,
  IconButton,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useNavigate } from 'react-router-dom';

import { ApiRequest } from 'GlobalFunctions';
import EmptyElement from 'elements/EmptyElement';
import BudgetCreate from './BudgetCreate';

const monthNames = [
  '', 'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

const statusLabels: any = {
  created: 'Creado',
  in_progress: 'En progreso',
  closed: 'Cerrado',
};

const statusColors: any = {
  created: 'default',
  in_progress: 'primary',
  closed: 'success',
};

export default function BudgetsList(props: any) {
  const { setLoading } = props;
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [list, setList] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [openCreate, setOpenCreate] = useState(false);

  useEffect(() => {
    loadList();
  }, [page]);

  const loadList = async () => {
    setLoading(true);

    await ApiRequest({
      url: "/budgets/list",
      method: "get",
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      query: {
        page: page,
      },
      setResponse: (response: any) => {
        setList(response.list || []);
        setTotalPages(response.total_pages || 0);
        setLoading(false);
      },
    });
  };

  const handleCreated = (budget_id: number) => {
    setOpenCreate(false);
    navigate(`/budgets/details/${budget_id}`);
  };

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
    }).format(value);
  };

  return (
    <div id='BudgetsList' className='ModuleContainer' style={{ maxWidth: 'none' }}>
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">Presupuestos</h2>
            <span className="h2_subtitle">Gestión de presupuestos mensuales</span>
          </div>

          <div className="boxContainerActions">
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenCreate(true)}
              startIcon={<AddIcon />}
            >
              Nuevo Presupuesto
            </Button>
          </div>
        </div>

        <div>
          <Box className='box100'>
            {list.length !== 0 ? (
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: 'none' }}>PERIODO</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: 'none' }}>USUARIOS</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: 'none' }}>PRESUPUESTO TOTAL</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: 'none' }}>REALIZADO TOTAL</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: 'none' }}>ESTADO</TableCell>
                      <TableCell sx={{ color: '#a8a8a8', borderBottom: 'none' }}></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {list.map((item: any, i: number) => (
                      <TableRow key={i} hover>
                        <TableCell>
                          <span className='flex_title'>
                            {monthNames[item.month]} {item.year}
                          </span>
                          <span className='flex_subtitle'>
                            {item.business_days} días lab. / {item.worked_days} días trab.
                          </span>
                        </TableCell>
                        <TableCell>
                          <span className='flex_title'>{item.total_users}</span>
                        </TableCell>
                        <TableCell>
                          <span className='flex_title'>{formatCurrency(item.total_budget_amount)}</span>
                        </TableCell>
                        <TableCell>
                          <span className='flex_title'>{formatCurrency(item.total_actual_sales)}</span>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={statusLabels[item.status] || item.status}
                            color={statusColors[item.status] || 'default'}
                            variant="outlined"
                            size="small"
                          />
                        </TableCell>
                        <TableCell align="right">
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            startIcon={<VisibilityIcon />}
                            onClick={() => navigate(`/budgets/details/${item.budget_id}`)}
                          >
                            Ver
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <EmptyElement
                title="No hay presupuestos registrados"
                subtitle="Crea un nuevo presupuesto para comenzar"
              />
            )}

            {totalPages > 1 && (
              <Pagination
                count={totalPages}
                page={page}
                onChange={(_event, value) => setPage(value)}
                color="primary"
                style={{ marginTop: '20px', alignSelf: 'center' }}
              />
            )}
          </Box>
        </div>
      </div>

      <BudgetCreate
        open={openCreate}
        setOpen={setOpenCreate}
        onCreated={handleCreated}
      />
    </div>
  );
}
